import {
  InsuranceCoverage,
  SpecialInsuranceCoverage,
} from "Store/interfaces/products/coverage";
import { useComponentTexts, useInsuranceTermsPdfLink } from "Store/texts/hooks";

import { DownloadButton } from "Components/DownloadButton";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { productBackendNameToInsuranceName } from "Components/Features/CheckPrice/Products/utils";
import { buttonTrackId } from "Utils/analytics";
import React from "react";

interface Props {
  readonly coverage?: InsuranceCoverage;
  readonly productBackendName?: ProductBackendName;
  readonly specialCoverage?: SpecialInsuranceCoverage;
  readonly isOnColoredBackground?: boolean;
}

export const InsuranceTermsPdfButton = ({
  coverage,
  productBackendName,
  specialCoverage,
  isOnColoredBackground,
}: Props): React.ReactElement | null => {
  const [{ insuranceTermsPdfLink: texts }, lang] = useComponentTexts();
  const insuranceName =
    productBackendName && productBackendNameToInsuranceName(productBackendName);

  const insuranceTermsKey = specialCoverage ?? coverage ?? insuranceName;
  const insuranceTermsPdfLink = useInsuranceTermsPdfLink(insuranceTermsKey);

  if (!insuranceTermsPdfLink) {
    return null;
  }

  let linkTexts = texts.buttonText[lang];

  if (specialCoverage) {
    linkTexts = texts[specialCoverage][lang];
  }

  return (
    <DownloadButton
      link={insuranceTermsPdfLink}
      text={linkTexts}
      className={buttonTrackId("download-insurance-terms")}
      isOnColoredBackground={isOnColoredBackground}
    />
  );
};
